import * as React from "react";
function XxlIcon() {
    return React.createElement("path", { d: "M9 45.0008V15.9356H18.7961V18.2048H11.2692V42.7317H36.7307V18.2048H29.1423V15.9356H38.9999V45.0009L9 45.0008ZM22.8346 30.5163V8.08941L18.2615 12.6625L16.6115 11.0318L23.9692 3.69336L31.3076 11.0318L29.6769 12.6625L25.1038 8.08941V30.5163H22.8346Z", fill: "currentColor" });
}
export default XxlIcon;
//# sourceMappingURL=Xxl.js.map